<template>
    <div>
        <!-- @TODO: Add this to a reusable component -->
        <div class="text-center">
            <div class="logo-device text-center mb-6">
                <span class="text-2xl -mr-2 font-semibold align-middle">4</span>
                <lottie-animation
                    class="inline-block align-middle"
                    :width="84"
                    :path="global.app.path + 'animations/o_icon_loading_animation.json'"
                />
                <span class="text-2xl -ml-2 font-semibold align-middle">4</span>
            </div>

            <h1 class="text-xl uppercase font-semibold mb-5">Page Not Found</h1>

            <p>The page you have requested could not be found.</p>
        </div>
        <!-- @ENDTODO -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "Error404Page",
    components: {},
    computed: {
        ...mapGetters(["global"]),
    },
    data: function () {
        return {};
    },
    methods: {},
};
</script>
